import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Box, Dialog, DialogContent, IconButton, MUIDataTable, Typography } from 'web-library';
import DialogTitle from '@mui/material/DialogTitle';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetExamRegistrationFeeDetails } from '../../../api-refactored/group-exam-registration/useGetExamRegistrationFeeDetails';
import ReviewSubjectDataColumn from '../../datatables/ReviewSubjectDataColumn';
import ExamFeeDetails from '../../ExamFeeDetails';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
export interface ViewFeeDetailsProps {
  feeModalOpen: { examRegistrationUuid: string; candidateName: string };
  onClose: () => void;
}

const useStyles = makeStyles()((theme) =>
({
  viewDetailsDialog: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      '&.MuiDialog-paper': {
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        '& .MuiDialogTitle-root': {
          padding: 0,
        },
        '& .MuiDialogContent-root': {
          padding: 0,
        },
        '& .MuiDialogActions-root': {
          padding: 0,
        },
      },
    },
  },
  // Mui DataTable css starts
  datatable: {
    marginBottom: theme.spacing(4),
  },
  subject: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
  },
  subjectName: {
    paddingBottom: theme.spacing(1),
  },
  optionalPaper: {
     ...typographyTheme(theme, 'subtitle2'),
    color: theme.color.text.textSecondary,
  },
  gridContainer: {
    marginBottom: theme.spacing(4),
  },
  feeCell: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  // Mui DataTable css ends
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    alignItems: 'center',
  },
  closeButton: {
    padding: 0,
  },
}));

const ViewFeeDetailsModal = ({ feeModalOpen, onClose }: ViewFeeDetailsProps) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const { uuid: applicationUuid } = useParams<any>();
  const { candidateName, examRegistrationUuid } = feeModalOpen;
  const { data: feeDetailsData } = useGetExamRegistrationFeeDetails({
    uuid: applicationUuid,
    examRegUuid: examRegistrationUuid,
    enabled: !!examRegistrationUuid,
  });
  const handleClose = () => {
    onClose();
  };

  const isIPsle =
    feeDetailsData?.groupedLevelFees?.length &&
    feeDetailsData?.groupedLevelFees.filter((item) => item.examLevel === 'iPSLE').length;

  return (
    (<Dialog
      className={classes.viewDetailsDialog}
      onClose={handleClose}
      open={!!candidateName && !!examRegistrationUuid}
      maxWidth="lg"
    >
      <Box className={classes.titleContainer}>
        <DialogTitle>
          <Typography variant="h4">{candidateName}</Typography>
        </DialogTitle>
        <IconButton
          className={classes.closeButton}
          name={IconName.cross}
          iconSize="S"
          color={theme.color.icon.iconDefault}
          ariaLabel="view-fee-detail-close"
          onClick={handleClose} />
      </Box>
      <DialogContent>
        {feeDetailsData && (
          <Box className={classes.datatable}>
            <MUIDataTable
              columns={ReviewSubjectDataColumn({
                dataContent: feeDetailsData.selectedSubjects,
                t,
                classes,
              })}
              data={feeDetailsData.selectedSubjects}
            />
          </Box>
        )}
        <ExamFeeDetails
          groupedLevelFees={feeDetailsData?.groupedLevelFees}
          payment={feeDetailsData?.payment}
          gstRegistrationNumber={
            !isIPsle || feeDetailsData?.payment.gstIndicator
              ? feeDetailsData?.gstRegistrationNumber
              : ''
          }
        />
      </DialogContent>
    </Dialog>)
  );
};

export default ViewFeeDetailsModal;
